import React from "react";
import AllData from "../../components/menu/table/component";

const Component = () => {
  return <AllData tableHeading="All Menus" />;
};

export default Component;
